<ng-template #content>
  @if (isOpen$ | async) {
    <mat-toolbar [color]="color" @toggle (@toggle.done)="onAnimationDone($event)">
      <div class="z-fx-grow">
        <ng-content></ng-content>
      </div>
    </mat-toolbar>
  }
</ng-template>
